/**
 * Arena shared visual atoms.
 *  - ArenaShield: small badge with the FitFrik shield + "ARENA" label.
 *  - ArenaConfetti: lightweight CSS particle bloom for celebrations.
 */
import { motion } from "framer-motion";

export function ArenaShield({ size = 16, label = "ARENA", showLabel = true }) {
  return (
    <span
      data-testid="arena-shield"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: showLabel ? "3px 8px 3px 4px" : 0,
        background: showLabel ? "rgba(245,197,24,0.16)" : "transparent",
        border: showLabel ? "1px solid rgba(245,197,24,0.45)" : "none",
        borderRadius: 100,
        fontFamily: "Barlow, sans-serif",
        fontSize: 9,
        fontWeight: 700,
        letterSpacing: "0.08em",
        color: "#0C0C0B",
      }}
    >
      <img src="/assets/arena/fitfrik-shield.jpg" alt="FitFrik" width={size} height={size} style={{ borderRadius: "50%", objectFit: "cover" }} />
      {showLabel && label}
    </span>
  );
}

export function ArenaConfetti() {
  const COUNT = 24;
  const particles = Array.from({ length: COUNT });
  return (
    <div style={{ position: "absolute", inset: 0, pointerEvents: "none", overflow: "hidden" }} aria-hidden>
      {particles.map((_, i) => {
        const angle = (i / COUNT) * Math.PI * 2;
        const r = 80 + Math.random() * 80;
        const dx = Math.cos(angle) * r;
        const dy = Math.sin(angle) * r;
        const colors = ["#F5C518", "#0C0C0B", "#22C55E", "#00D4FF", "#FF6B6B"];
        const color = colors[i % colors.length];
        return (
          <motion.span
            key={i}
            initial={{ x: 0, y: 0, opacity: 1, rotate: 0 }}
            animate={{ x: dx, y: dy, opacity: 0, rotate: 360 }}
            transition={{ duration: 1.4, ease: "easeOut", delay: Math.random() * 0.2 }}
            style={{
              position: "absolute", left: "50%", top: "50%",
              width: 8, height: 8,
              borderRadius: 2,
              background: color,
            }}
          />
        );
      })}
    </div>
  );
}
